import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    q: "What format does the book come in?",
    a: "$16.99 gets you instant access to a high-quality PDF and EPUB after checkout. Both are optimized for tablet, phone and Kindle.",
  },
  {
    q: "How long does it actually take to read?",
    a: "Each of the 30 chapters is intentionally short — 6 to 10 minutes. The work is in the daily execution, not in reading volume.",
  },
  {
    q: "Is this for beginners or advanced readers?",
    a: "Both. The system meets you where you are. Beginners get scaffolding; experienced readers get a sharper standard to push against.",
  },
  {
    q: "Do I need to do all 30 days back-to-back?",
    a: "Yes — that is the system. Missing a day means restarting the current phase. The friction is the feature.",
  },
  {
    q: "Will there be a physical copy?",
    a: "A premium hardback edition is planned for early 2027. Subscribers on the list get first access and a pre-order discount.",
  },
  {
    q: "Refund policy?",
    a: "30-day full refund. If you ran the system and feel it didn't deliver, email us and we'll return your $16.99 — no questions.",
  },
];

export default function Faq() {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="relative py-24 md:py-32 border-t border-white/5"
    >
      <div className="max-w-4xl mx-auto px-6 md:px-10">
        <div className="text-center mb-14">
          <p className="text-xs uppercase tracking-[0.3em] text-[#d4af37]/80">
            FAQ
          </p>
          <h2 className="font-serif-display mt-4 text-4xl sm:text-5xl text-white leading-[1.05] tracking-tight">
            Honest answers, <em className="gold-text">no fluff.</em>
          </h2>
        </div>

        <Accordion
          type="single"
          collapsible
          className="space-y-3"
          data-testid="faq-accordion"
        >
          {faqs.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              data-testid={`faq-item-${i}`}
              className="border border-white/5 rounded-xl bg-[#121212] data-[state=open]:border-[#d4af37]/30 transition-colors px-5"
            >
              <AccordionTrigger className="text-left text-base md:text-lg text-white hover:no-underline hover:text-[#e5c158] py-5">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-neutral-400 leading-relaxed pb-5">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
